/* eslint-disable key-spacing */
// @flow
import { isEmpty } from 'lodash';
import moment from 'moment';

// mostly obtained from https://www.gov.nl.ca/hcs/files/mcp-providers-pim-residents-of-other-provinces.pdf
const HCN_REGEXES = {
  Ontario:                      /(\d{4})(\d{3})(\d{3})(\D{0,2})/,
  'Prince Edward Island':       /(\d{4})(\d{4})/,
  Alberta:                      /(\d{5})(\d{4})/,
  'British Columbia':           /(\d{4})(\d{3})(\d{3})/,
  'Nova Scotia':                /(\d{4})(\d{3})(\d{3})/,
  Manitoba:                     /(\d{3})(\d{3})(\d{3})/,
  'New Brunswick':              /(\d{3})(\d{3})(\d{3})/,
  Nunavut:                      /(\d{3})(\d{3})(\d{3})/,
  Saskatchewan:                 /(\d{3})(\d{3})(\d{3})/,
  Yukon:                        /(\d{3})(\d{3})(\d{3})/,
  'Newfoundland and Labrador':  /(\d{0,12})/,
  'Northwest Territories':      /([nN]\d{7})/,
  Québec:                       /([a-zA-Z]{4})(\d{4})(\d{4})/
};

const EXAMPLE_HCNS = {
  Ontario:                      '1212-121-121-AM',
  'Prince Edward Island':       '1212-1212',
  Alberta:                      '12345-6789',
  'British Columbia':           '1212-121-121',
  'Nova Scotia':                '1234-567-897',
  Manitoba:                     '123-123-123',
  'New Brunswick':              '123-123-123',
  Nunavut:                      '123-123-123',
  Saskatchewan:                 '123-123-123',
  Yukon:                        '123-123-123',
  'Newfoundland and Labrador':  '123456789123',
  'Northwest Territories':      'N1234567',
  Québec:                       'ABCD-1234-1234'
};

const postalCodeRegex = /^([ABCEGHJ-NPRSTVXY])(\d)([ABCEGHJ-NPRSTV-Z])[ -]?(\d)([ABCEGHJ-NPRSTV-Z])(\d)$/i;

export const formatHCN = (value, province) => {
  if (HCN_REGEXES[province]) {
    const x = value
      .replace(/[^A-Za-z0-9]/g, '')
      .match(HCN_REGEXES[province]);
    if (x && x[1] && x[2] && x[3] && x[4]) {
      return `${x[1]}-${x[2]}-${x[3]}-${x[4]}`.toUpperCase();
    } else if (x && x[1] && x[2] && x[3]) {
      // keep trailing hyphen (or symbol) if there is one, for ON format
      const trailingChar = value[value.length - 1];
      if (province === 'Ontario' && (/[^A-Za-z0-9]/).test(trailingChar)) {
        return `${x[1]}-${x[2]}-${x[3]}${trailingChar}`.toUpperCase();
      }
      return `${x[1]}-${x[2]}-${x[3]}`.toUpperCase();
    } else if (x && x[1] && x[2]) {
      return `${x[1]}-${x[2]}`.toUpperCase();
    } else if (x && x[1]) {
      return x[1].toUpperCase();
    }
    return value.toUpperCase();
  }
  return value;
};

export const validateHCN = (value: string, province: string, msg?: string, example?: string) => {
  const rawValue = value.replace(/[^A-Za-z0-9]/g, '');
  if (!rawValue || rawValue.length < 1) {
    return `${msg}${EXAMPLE_HCNS[province] ? ` ${example} ${EXAMPLE_HCNS[province]}` : ''}`;
  }
  if (!HCN_REGEXES[province] || HCN_REGEXES[province].test(rawValue)) {
    return null;
  }
  return `${msg}${EXAMPLE_HCNS[province] ? ` ${example} ${EXAMPLE_HCNS[province]}` : ''}`;
};

export const formatDOB = (value: string) => {
  const x = value.replace(/\D/g, '').match(/(\d{0,4})(\d{0,2})(\d{0,2})/);
  let str = '';
  if (!x[2]) {
    if (x[1].length === 4) {
      str += `${x[1]}-`;
    } else {
      str += x[1];
    }
  } else {
    if (x[2].length === 2) {
      str += `${x[1]}-${x[2]}-`;
    } else {
      str += `${x[1]}-${x[2]}`;
    }

    if (x[3]) {
      str += `${x[3]}`;
    }
  }
  return str;
};

export const isValidDate = (value: string | Date) => {
  return moment(value, 'YYYY-MM-DD').isValid() && isEmpty(moment(value, 'YYYY-MM-DD').parsingFlags().unusedTokens);
};

export const isValidDOB = (value: string | Date) => {
  if (isValidDate(value)) {
    return moment(value, 'YYYY-MM-DD').isBetween(
      moment().subtract(120, 'years').format('YYYY-MM-DD'),
      moment().subtract(18, 'years').format('YYYY-MM-DD'),
      undefined,
      '[]'
    );
  }
  return false;
};

const isValidPostalCode = (value: string) => {
  return postalCodeRegex.test(value);
};

export const validatePostalCode = (value: string, msg: string) => {
  if (!isValidPostalCode(value)) {
    return msg;
  }
  return null;
};

export const getValidPostalCode = (code) => {
  return code.replace(postalCodeRegex, '$1$2$3 $4$5$6').toUpperCase();
};



// WEBPACK FOOTER //
// ./src/validators/authorize-request.js